import React, { useEffect, useContext, useReducer } from 'react';
import { store as reportsStore } from '../../reducer';
import { makeStyles } from '@material-ui/core/styles';
import { reducer, initialState, store } from './reducer';
import axios from '../../../../../../api/axios';
import Filters from './Filters';
import List from './List';
import { store as mainStore } from '../../../../../../store';
import useRules from 'hooks/useRules';
import useTitle from 'hooks/useTitle';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'grid',
    gridTemplateColumns: '1fr',
    gridGap: theme.spacing(1),
  },
}));

const Daily = () => {
  useTitle('گزارش روزانه پورسانت ها');
  const classes = useStyles();
  const [rules, hasRule, isAdmin] = useRules();
  const {
    state: {
      Auth: { profile },
    },
  } = useContext(mainStore);
  const {
    dispatch: reportsDispatch,
    showMessage,
    showError,
    itemsCountPerPage,
  } = useContext(reportsStore);
  const { Provider } = store;
  const [state, dispatch] = useReducer(reducer, initialState);
  const { date, customers, drivers, operators, page, user } = state;

  const makeReport = async () => {
    try {
      dispatch({ type: 'PROGRESS', payload: true });
      const { data: reports } = await axios.post(
        `/api/v1/admin/reports/commissionDepositsForDate`,
        {
          date,
          customers,
          drivers,
          operators,
          page,
          limit: itemsCountPerPage,
          user:
            hasRule('can_manage_operators') || isAdmin
              ? user?.[0]?._id
              : profile._id,
        }
      );
      dispatch({ type: 'REPORTS', payload: reports });
    } catch (error) {
      showError(error);
    }
    dispatch({ type: 'PROGRESS', payload: false });
  };

  useEffect(() => {
    reportsDispatch({
      type: 'CHANGE_TITLE_CATEGORY',
      payload: {
        title: 'گزارش روزانه ‌پورسانت‌ها',
        category: 'جهت گزارش پورسانت‌های واریز جهت کاربری های مشخص شده',
      },
    });
  }, []);

  useEffect(() => {
    makeReport();
    // reportTotalCommission();
  }, [date, customers, drivers, operators, page, itemsCountPerPage, user]);

  return (
    <Provider
      value={{
        state,
        dispatch,
        showMessage,
        showError,
        itemsCountPerPage,
        makeReport,
      }}
    >
      <div className={classes.root}>
        <Filters />
        <List />
      </div>
    </Provider>
  );
};

export default React.memo(Daily);
